export default __webpack_public_path__ + "static/media/product-image-2.d09d88dc.jpg";